import React from "react";
import styles from "./styles.module.css";

export const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>
        2023 Todos os direitos reservados{" "}
        <a href="https://taxationmind.com.br" target="_blank" rel="noreferrer">
          Taxation Mind®
        </a>
      </p>
    </footer>
  );
};
